import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_MealType } from "../shared/data.service";
import { IntStringRequest } from "../shared/IntStringRequest";
import { MealModifyRequest } from "../shared/MealModifyRequest";
import { MealNameRequest } from "../shared/MealNameRequest";
import { SubsidyPricingTableComponent } from "./subsidy-pricing-table/subsidy-pricing-table.component";
import * as moment from "moment";

@Component({
	selector: "app-meal-type-modify",
	templateUrl: "./meal-type-modify.component.html",
	styleUrls: ["./meal-type-modify.component.css"],
})
export class MealTypeModifyComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private MealTypeService: DataService_MealType
	) {}

	ngOnInit(): void {
		//
		// Get data from parent
		//

		this.user = this.dialogConfig.data.user;
		this.IsDistrictUser = this.user.UserLevelID == 1;

		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SchoolName = this.dialogConfig.data.SchoolName;
		this.EditMode = this.dialogConfig.data.EditMode;

		if (this.EditMode == true) {
			this.MealID = this.dialogConfig.data.MealID;
			this.MealName = this.dialogConfig.data.MealName;
			this.StartTime = new Date(this.dialogConfig.data.StartTime);
			this.EndTime = new Date(this.dialogConfig.data.EndTime);
			this.MealPrice = this.dialogConfig.data.MealPrice;
		} else {
			this.MealID = -1;
		}
	}

	/////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////

	@ViewChild(SubsidyPricingTableComponent)
	tableRef: SubsidyPricingTableComponent;

	user: any;
	IsDistrictUser: any = false;
	EditMode: any = false;
	MealID: any;

	MealName: any = "";
	StartTime: Date = new Date();
	EndTime: Date = new Date();
	MealPrice: any;
	SchoolID: any = -1;
	SchoolName: any = "";

	SchoolOpt: any = "School"; //School or District

	processing: any = false;
	errorMessage: any = "";

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////
	onAdd() {
		this.errorMessage = "";
		this.processing = true;

		//
		// Error handling
		//

		var fsTime = moment(this.StartTime).format("MM/DD/YYYY HH:mm:00");
		var feTime = moment(this.EndTime).format("MM/DD/YYYY HH:mm:00");

		if (String(fsTime).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid Start Time";

			this.processing = false;
			return;
		}

		if (String(feTime).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid End Time";

			this.processing = false;
			return;
		}

		if (this.MealPrice == undefined) {
			this.errorMessage = "Enter the regular meal price";
			this.processing = false;
			return;
		}

		if (this.MealPrice < 0) {
			this.MealPrice = 0;
		}
		// else if(this.MealPrice > 100){
		//   this.MealPrice = 100;
		// }

		if (this.MealName == "") {
			this.errorMessage = "Enter Meal Name";
			this.processing = false;
			return;
		} else {
			this.CheckName();
		}
	}

	CheckName() {
		let parms: MealNameRequest = {
			MealID: this.MealID,
			MealName: this.MealName,
			SchoolID: this.SchoolID,
		};

		var result = this.MealTypeService.MealNameUsed(parms);
		result.subscribe(
			(response) => {
				if (!response) {
					if (this.EditMode == false) {
						this.FinishAdd();
					} else {
						this.FinishEdit();
					}
				} else {
					this.processing = false;
					this.errorMessage = "ERROR: Meal Name already in use";
				}
			},
			(error) => {
				this.processing = false;
				this.errorMessage = "ERROR checking Meal Name";
			}
		);
	}

	FinishAdd() {
		//
		// Create Request
		//

		var fsTime = moment(this.StartTime).format("MM/DD/YYYY HH:mm:00");
		var feTime = moment(this.EndTime).format("MM/DD/YYYY HH:mm:00");

		var lstMST: number[] = [];
		var lstMealPCT: string[] = [];
		var lstMealCost: string[] = [];
		var lstUsePCT: number[] = [];

		for (var z = 0; z < this.tableRef.lstMealSubsidyType.length; z++) {
			var next = this.tableRef.lstMealSubsidyType[z];

			lstMST = [...lstMST, next.MealSubsidyTypeID];
			lstMealPCT = [...lstMealPCT, next.MealCostSubsidyPct];
			lstMealCost = [...lstMealCost, next.MealCostAmount];
			lstUsePCT = [...lstUsePCT, next.UsePct];
		}

		let parms: MealModifyRequest = {
			MealID: this.MealID,
			MealName: this.MealName,
			StartTime: fsTime,
			EndTime: feTime,
			MealPrice: this.MealPrice,
			SchoolID: this.SchoolOpt == "School" ? this.SchoolID : 0,
			lstMealSubsidyTypeIDs: lstMST,
			lstMealSubsidyPct: lstMealPCT,
			lstMealCostAmount: lstMealCost,
			lstUsePCT: lstUsePCT,
		};

		//
		// Call SP
		//
		var result = this.MealTypeService.MealInsert(parms);
		result.subscribe(
			(response) => {
				this.processing = false;

				if (this.AllClear(response)) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Meal Type Added Successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the Meal Type: " + response[0],
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.processing = false;
			}
		);
	}

	FinishEdit() {
		//
		// Create Request
		//

		var fsTime = moment(this.StartTime).format("MM/DD/YYYY HH:mm:00");
		var feTime = moment(this.EndTime).format("MM/DD/YYYY HH:mm:00");

		var lstMST: number[] = [];
		var lstMealPCT: string[] = [];
		var lstMealCost: string[] = [];
		var lstUsePCT: number[] = [];

		for (var z = 0; z < this.tableRef.lstMealSubsidyType.length; z++) {
			var next = this.tableRef.lstMealSubsidyType[z];

			lstMST = [...lstMST, next.MealSubsidyTypeID];
			lstMealPCT = [...lstMealPCT, next.MealCostSubsidyPct];
			lstMealCost = [...lstMealCost, next.MealCostAmount];
			lstUsePCT = [...lstUsePCT, next.UsePct];
		}

		let parms: MealModifyRequest = {
			MealID: this.MealID,
			MealName: this.MealName,
			StartTime: fsTime,
			EndTime: feTime,
			MealPrice: this.MealPrice,
			SchoolID: this.SchoolID,
			lstMealSubsidyTypeIDs: lstMST,
			lstMealSubsidyPct: lstMealPCT,
			lstMealCostAmount: lstMealCost,
			lstUsePCT: lstUsePCT,
		};

		//
		// Call SP
		//
		var result = this.MealTypeService.MealUpdate(parms);
		result.subscribe(
			(response) => {
				this.processing = false;

				if (this.AllClear(response)) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Meal Type Updated Successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Meal Type: " + response[0],
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.processing == true;
	}

	AllClear(lstErrors): boolean {
		var ans = true;

		for (var z = 0; z < lstErrors.length; z++) {
			var next = lstErrors[z];

			if (String(next) != "") {
				ans = false;
				return;
			}
		}

		return ans;
	}

	/////////////////////////////////////////////////////////////////
}
